const formActions = require('react-redux-form').actions;
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');

const getIcomeRange = dispatch => {
    Api.get(apiURLBuilder.getURL('getInComeRanges')).then(response => {
        if (response.body) {
            dispatch(formActions.change('extraData.IncomeRanges', response.body));
        }
    });
};

const getAllIcomeRange = () => {
    return dispatch => {
        getIcomeRange(dispatch);
    };
};

const saveEmployedInformationService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('fiocEmployed'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const saveEmployedInformation = (data, accessToken, callback = null) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };

        saveEmployedInformationService(dispatch, saveRequestData, callback);
    };
};

const saveSelfEmployedInformationService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('fiocOwnaccount'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const saveSelfEmployedInformation = (data, accessToken, callback = null) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };
        saveSelfEmployedInformationService(dispatch, saveRequestData, callback);
    };
};

const savePensionerInformationService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('fiocPensioner'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const savePensionerInformation = (data, accessToken, callback = null) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };
        savePensionerInformationService(dispatch, saveRequestData, callback);
    };
};

const saveRentierInformationService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('fiocRentier'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const saveRentierInformation = (data, accessToken, callback = null) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };
        saveRentierInformationService(dispatch, saveRequestData, callback);
    };
};

const saveUnemployedInformationService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('fiocUnemployed'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const saveUnemployedInformation = (data, accessToken, callback = null) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: data,
        };
        saveUnemployedInformationService(dispatch, saveRequestData, callback);
    };
};

export default {
    getAllIcomeRange,
    saveEmployedInformation,
    saveSelfEmployedInformation,
    savePensionerInformation,
    saveRentierInformation,
    saveUnemployedInformation,
};
